module.exports = __webpack_public_path__ + "img/product-0-3.78043421.png";